<mat-card *ngIf="!loading" class="mcd-card">
  <mat-card-header class="mcd-card-header" style="
      display: flex;
      justify-content: space-between;
      padding-right: 12px;
      background: transparent;
      border: 1px solid #a0a0a04d;
      color: #34393f;
      border-left: none;
    ">
    <mat-card-title class="mcd-card-title">Manage Suppliers</mat-card-title>
  </mat-card-header>
  <div class="breadcrumbs clearfix">
    <div class="breadcrumbs-inner">
      <ul>
        <li>
          <a routerLink="/global-admin-panel" routerLinkActive="active">Global Admin Panel</a>
        </li>
        <li class="separator">></li>
        <li class="active">Manage Suppliers</li>
      </ul>
    </div>
  </div>
  <mat-card-content class="mcd-card-content">
    <div class="row filter-panel-row"
      style="align-items: center; margin-bottom: 20px; display: flex; justify-content: space-between;">
      <div class="col-auto d-flex align-items-center" style="display: flex; gap: 15px; flex-wrap: wrap;">
        <!-- Search Input matching Upcoming Standards -->
        <div class="mcd-filter-dropdown-wrapper search-wrapper">
          <div class="mcd-search-header">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text" placeholder="Search by Name or Description" class="search-input-field"
              [value]="searchKey" (keyup.enter)="addSearchKey(key.value)" #key />
            <button type="button" class="clear-button" *ngIf="searchKey" (click)="searchKey = ''; addSearchKey('')">
              <mat-icon class="clear-icon">close</mat-icon>
            </button>
          </div>
        </div>

        <!-- Country Filter Dropdown Pill -->
        <div class="mcd-filter-dropdown-wrapper country-dropdown-wrapper" style="position: relative;">
          <div class="mcd-dropdown-header">
            <div class="dropdown-trigger-btn" role="button" tabindex="0" (click)="toggleCountryDropdown()" [style]="
                isCountryDropdownOpen || displayCountryCount > 0
                  ? 'border: 1px solid #6574C4; background: #F8F9FF;'
                  : 'border: 1px solid #DDE1E6;'
              ">
              <span class="trigger-label">{{ getCountryDisplayText() }}</span>
              <button type="button" class="remove-button" *ngIf="displayCountryCount > 0"
                (click)="removeCountryFilter($event)" aria-label="Clear country filter">
                <img src="/assets/images/s-remove 1.svg" alt="Clear" />
              </button>
              <span class="trigger-chevron">
                <img src="/assets/images/down-arrow 1.svg" height="16px" width="16px" [style.transform]="
                    isCountryDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)'
                  " [style.transition]="'transform 0.3s ease'" />
              </span>
            </div>
          </div>

          <div class="mcd-dropdown-content" *ngIf="isCountryDropdownOpen">
            <div class="mcd-dropdown-search">
              <mat-icon class="search-icon">search</mat-icon>
              <input type="text" placeholder="Search country" [(ngModel)]="countrySearchText"
                (input)="filterCountries()" class="search-input" />
            </div>

            <div class="mcd-dropdown-options">
              <div class="dropdown-option-item">
                <mat-checkbox [checked]="isAllCountriesSelected()" (change)="onAllCountriesChange($event)"
                  (click)="$event.stopPropagation()">
                  All Countries
                </mat-checkbox>
              </div>
              <div class="filter-selected-divider" *ngIf="tempSelectedCountryIds.length === 0"></div>

              <ng-container *ngFor="let item of filteredCountries; let i = index">
                <div class="dropdown-option-item">
                  <mat-checkbox [checked]="isCountrySelected(item.id)" (change)="onCountryFilterChange($event, item.id)"
                    (click)="$event.stopPropagation()">
                    {{ item.name }}
                  </mat-checkbox>
                </div>
                <div class="filter-selected-divider" *ngIf="showFilterDivider(i)"></div>
              </ng-container>

              <div class="no-results" *ngIf="filteredCountries.length === 0">
                No countries found
              </div>
            </div>

            <div class="dropdown-actions">
              <button type="button" class="apply-btn" (click)="applyCountryFilter()">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-auto text-right">
        <button class="btn-add-supplier-gold" (click)="onAddEditSupplier()">
          <span class="material-icons add-icon">add_circle_outline</span>
          Add New Supplier
        </button>
      </div>
    </div>

    <div class="table-wrapper" *ngIf="supplierList.globalMarketSuppliers.length > 0">
      <table class="table nrbes-grid">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="22%">Name</th>
            <th scope="col" width="15%">Logo</th>
            <th scope="col" width="25%">Markets Assigned</th>
            <th scope="col" width="33%">Description</th>
            <th scope="col" width="5%" style="text-align: center;"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of supplierList.globalMarketSuppliers" (click)="rowSelected(item)">
            <td class="location-cell" style="color: #3949a3; font-size: 14px;">
              {{ item.supplier.name }}
            </td>
            <td class="title-cell">
              <div class="mcd-supplier-logo">
                <img [src]="item?.supplier?.supplierLogoAttachment?.image" class="img-fluid"
                  style="max-height: 28px;" />
              </div>
            </td>
            <td style="color: #475569; font-size: 14px;">
              {{ getAssignedMarketsText(item) }}
            </td>
            <td class="description">
              <span title="{{ item.supplier.description }}" class="description">
                {{ item.supplier.description }}
              </span>
            </td>
            <td (click)="$event.stopPropagation()" style="text-align: center;">
              <div class="grid-actions hide-sm" style="position: relative;">
                <button style="border: none; background: none; cursor: pointer;" (click)="togglePopup($event, item)">
                  <img src="/assets/images/menu-dots 2.svg" />
                </button>

                <div class="action-popup editDeletModal" *ngIf="activePopupId === item.supplier.id">
                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="onEditHover"
                    (click)="onEdit(item, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(63, 81, 181, 1);
                        font-size: 14px;
                        text-align: left;
                        display: block;
                        width: 100%;
                      " title="Edit" href="javascript:void(0);">
                      <span><img src="/assets/images/d-edit 1.svg"
                          style="margin-bottom: 4px; margin-right: 5px;" /></span>
                      <span>Edit</span>
                    </a>
                  </div>

                  <hr style="margin: 2px; border: 1px solid #dde1e6;" />

                  <div style="padding: 8px; text-align: left; cursor: pointer;" class="oDeleteHover"
                    (click)="openDeleteModal(item, $event)">
                    <a class="action-controls" style="
                        text-decoration: none;
                        color: rgba(222, 52, 40, 1);
                        font-size: 14px;
                        display: block;
                        width: 100%;
                      " title="Delete" href="javascript:void(0);">
                      <span><img src="/assets/images/bin.svg" style="margin-bottom: 4px; margin-right: 5px;" /></span>
                      <span>Delete</span>
                    </a>
                  </div>
                </div>
              </div>

              <a (click)="actionMenuOpen($event)" class="mcd-more-btn show-sm" [matMenuTriggerFor]="menu"
                href="javascript:void(0);">
                <i class="material-icons">more_vert</i>
              </a>
              <mat-menu #menu="matMenu" overlapTrigger="false">
                <span>
                  <button mat-menu-item (click)="onAddEditSupplier(item.supplier.id)">
                    Edit
                  </button>
                  <button mat-menu-item (click)="closeMatMenuAndOpenDeleteModal(item, $event)">
                    Remove
                  </button>
                </span>
              </mat-menu>
            </td>
          </tr>
        </tbody>
      </table>

      <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        " *ngIf="supplierList.globalMarketSuppliers.length > 0">
        <div>
          <div>
            <mat-form-field>
              <mat-select style="
                  padding: 8px 16px;
                  border: 1px solid #dde1e6;
                  border-radius: 4px;
                  background-color: #f8fafb;
                  color: #4d5258;
                  font-weight: 500;
                " [value]="pageSize" name="nOfRows" #items (selectionChange)="selectedItemsPerPageChange(items)">
                <mat-option [value]="item.value" *ngFor="let item of pageSizes">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div>
          <div>
            <ngb-pagination class="float-right" [(page)]="page" [pageSize]="pageSize" [maxSize]="4" [rotate]="true"
              [ellipses]="true" [collectionSize]="collectionSize" (pageChange)="getSuppliers()"></ngb-pagination>
          </div>
        </div>

        <div style="display: flex; gap: 10px">
          <button class="prevButton" [ngStyle]="{
              border: page == 1 ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == 1 ? '#696F77' : '#34393f',
            }" (click)="goToPreviousPage()">
            <img src="/assets/images/leftarrow.svg" />

            Previous
          </button>
          <button class="nextButton" [ngStyle]="{
              border:
                page == totalPages ? '1px solid #E9ECEF' : '1px solid #C1C6CD',
              color: page == totalPages ? '#696F77' : '#34393f',
            }" (click)="goToNextPage()">
            Next
            <img src="/assets/images/rightarrow.svg" />
          </button>
        </div>
      </div>
    </div>

    <div class="noResults" *ngIf="supplierList.globalMarketSuppliers.length == 0 && !searchKey">
      Sorry you do not have any supplier.
    </div>

    <div class="search-empty-state" *ngIf="supplierList.globalMarketSuppliers.length == 0 && searchKey">
      <img
        src="/assets/images/GRBES-List.svg"
        alt=""
        class="search-empty-icon"
      />
      <h4 class="search-empty-title">No results found</h4>
      <p class="search-empty-subtitle">
        Try a different keyword or refine your search to find what you're
        looking for.
      </p>
    </div>
  </mat-card-content>
</mat-card>
<app-mcd-loader class="mcd-page-loader" *ngIf="loading"></app-mcd-loader>